import React from 'react';
import PropTypes from 'prop-types';

import goldstar from '../../../../images/user/gold-star.png';
import fanclub from '../../../../images/fanclub-icon.png';
import crown from '../../../../images/performerVideo/leader-crown.png';
import styles from '../ChatMessageTypes.css';


const types = {
  goldstar: {
    src: goldstar,
    alt: 'goldstar',
    className: styles.goldstar,
  },
  fanclub: {
    src: fanclub,
    alt: 'blue star',
    className: styles.fanclub,
  },
  crown: {
    src: crown,
    alt: 'leader crown',
    className: styles.leaderCrown,
  },
};

const ImageIcon = (props) => {
  const { alt, src, className } = types[props.type];

  return <img alt={alt} className={className} src={src} />;
};

ImageIcon.propTypes = { type: PropTypes.oneOf(Object.keys(types)).isRequired };

export default ImageIcon;
